/**
 * 发版更新弹窗正文排版与自适应宽度（mp / shop / repair 同步）。
 */

export const UPGRADE_BODY_MAX_LINES = 10;
/** MessageBox 左右内边距 + 边框余量 */
export const UPGRADE_DIALOG_H_PAD = 72;
export const UPGRADE_DIALOG_MIN_W = 420;

export function escapeHtml(text: string): string {
	return text
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;");
}

/** 后台条目可能含换行，展示时压成空格，由外层按条分行 */
export function flattenLine(s: string): string {
	return s.replace(/\r?\n+/g, " ").trim();
}

/** 将内容像素宽夹到弹窗可用宽度（可单测，不依赖 DOM） */
export function clampUpgradeDialogWidth(contentPx: number, innerWidth: number): number {
	const cap = Math.floor(innerWidth * 0.9);
	return Math.min(cap, Math.max(UPGRADE_DIALOG_MIN_W, Math.ceil(contentPx + UPGRADE_DIALOG_H_PAD)));
}

/**
 * 按最长一行文字量宽，夹在 min ～ 90vw 之间。
 */
export function measureUpgradeDialogWidth(message: string, changes: string[]): string {
	const lines = [
		flattenLine(message),
		...changes.slice(0, UPGRADE_BODY_MAX_LINES).map(flattenLine)
	].filter(Boolean);
	if (!lines.length) return `${UPGRADE_DIALOG_MIN_W}px`;

	const probe = document.createElement("div");
	probe.style.cssText =
		"position:absolute;left:-9999px;top:0;visibility:hidden;white-space:nowrap;" +
		"font-size:14px;line-height:1.7;font-family:var(--el-font-family,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif);";
	document.body.appendChild(probe);
	let maxPx = 0;
	try {
		for (const line of lines) {
			probe.textContent = line;
			maxPx = Math.max(maxPx, probe.offsetWidth);
		}
	} finally {
		probe.remove();
	}

	return `${clampUpgradeDialogWidth(maxPx, window.innerWidth)}px`;
}

/**
 * 更新说明：概述单独一行，每条 change 各占一行（无图标、无 ul 项目符号）。
 */
export function renderUpgradeBodyHtml(message: string, changes: string[]): string {
	const chunks: string[] = [];
	const msg = flattenLine(message);
	if (msg) {
		chunks.push(
			`<div style="margin:0 0 8px;line-height:1.6;color:#303133;word-break:break-word;">${escapeHtml(msg)}</div>`
		);
	}
	const lines = changes.slice(0, UPGRADE_BODY_MAX_LINES).map(flattenLine).filter(Boolean);
	for (const line of lines) {
		chunks.push(
			`<div style="margin:0;line-height:1.7;color:#606266;word-break:break-word;">${escapeHtml(line)}</div>`
		);
	}
	if (changes.length > UPGRADE_BODY_MAX_LINES) {
		chunks.push(
			`<div style="margin:4px 0 0;line-height:1.7;color:#909399;">…等 ${changes.length} 条</div>`
		);
	}
	return chunks.join("");
}
